export default "__VITE_ASSET__qNGJxYzg__"